import { parseBrandAssets } from '~/brand/assets'

/**
 * Логотипы и фавиконку бренда настраивают в CRM вместе с личным кабинетом,
 * терминал берёт их из публичного API кабинета до монтирования приложения.
 * Без адреса или при ошибке запроса остаются локальные файлы бренда.
 */
export default defineNuxtPlugin(async () => {
  const { brandSettingsUrl } = useRuntimeConfig().public

  if (!brandSettingsUrl) return

  const brandAssets = useBrandAssets()

  try {
    const response = await $fetch<unknown>(brandSettingsUrl, { timeout: 5000 })
    brandAssets.value = parseBrandAssets(response, brandSettingsUrl, brandAssets.value)
  } catch (error) {
    console.warn('[brand] Failed to load brand settings, using local assets', error)
  }
})
